module.exports = __webpack_public_path__ + "static/media/banner-2024.b1bd82f6.jpg";